module.exports = __webpack_public_path__ + "li.svg?f37f498e8d8d43d49133b6b2de2b447b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/li.svg
// module id = 1467
// module chunks = 0